import { CryptoPayoutStatus } from 'types/cryptoPayout';

import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'pages.cryptoPayout.details.events';

const LABELS = makeLabels(
  {
    TITLE: ['title', 'Events'],
  },
  NAMESPACE,
);

export const KEYS = {
  FAILED_STATUSES: [CryptoPayoutStatus.Failed, CryptoPayoutStatus.Canceled],
};

export default LABELS;
